import withCart from '../General/withCart';
import ReactTooltip from 'react-tooltip'
var formatMoney = require('../General/Helper').formatMoney;


class SiteBudgetData extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.cart == null || this.props.cart.hideBudget || this.props.hidePrices) {
            return null;
        }

        var monthlyBudget = 0, monthlySpend = 0, totalPrice = 0;
        var spendPerAccount = false;
        var glCollection = [];
        var spendBreakDown = {};
        if (this.props.cart.address != null) {
            spendPerAccount = this.props.cart.address.glMonthlyBudget;
            glCollection = this.props.cart.address.glBudgetLineCollection;
            var glLookup = {};
            for (var i = 0; i < glCollection.length; i++) {
                glLookup[glCollection[i].glAccount.code] = glCollection[i];
            }

            if (this.props.cart.address.monthlyBudget != null) {
                monthlyBudget = this.props.cart.address.monthlyBudget;
            }
            if (this.props.cart.address.monthlySpend != null) {
                monthlySpend = this.props.cart.address.monthlySpend - this.props.cart.address.rechargeableSpend;
            }

            if (this.props.cart.totalPrice != null) {
                totalPrice = 0;
                for (var i = 0; i < this.props.cart.lines.length; i++) {
                    var line = this.props.cart.lines[i];
                    if (!line.rechargeable) {
                        totalPrice += line.lineTotal;
                    }
                }
            } 

            if (this.props.cart.address.spendBreakdown) {
                for (var i = 0; i < this.props.cart.address.spendBreakdown.length; i++) {
                    var spendLine = this.props.cart.address.spendBreakdown[i];

                    if(spendBreakDown[spendLine.glCode] == null) {
                        spendBreakDown[spendLine.glCode] = 0;
                    }

                    spendBreakDown[spendLine.glCode] += spendLine.nonRechargeableSpend + spendLine.rechargeableSpend;

                    if (spendLine.glCode != null && !glLookup[spendLine.glCode] ) {
                        glLookup[spendLine.glCode] = { amount: 0, glAccount: { name: spendLine.glName, code: spendLine.glCode}};
                        glCollection.push(glLookup[spendLine.glCode]);
                    }
                }
            }
            
        }

        var cartAccountSpend = {};

        for (var i = 0; i < this.props.cart.lines.length; i++) {
            var line = this.props.cart.lines[i];
            if (cartAccountSpend[line.generalLedgerCode] == null) {    
                cartAccountSpend[line.generalLedgerCode] = 0;
            }
            cartAccountSpend[line.generalLedgerCode] += line.lineTotal;

            if (line.generalLedgerCode != null && !glLookup[line.generalLedgerCode]) {
                glLookup[line.generalLedgerCode] = { amount: 0, glAccount: { name: line.generalLedgerCode, code: line.generalLedgerCode } };
                glCollection.push(glLookup[line.generalLedgerCode]);
            };
        }

        function ifNull(value) {
            if (value == null) {
                return 0;
            }
            return value;
        }


       

        return <div>
            <hr />
                <div className="budget-area">
                   <strong>Site budget <i className="icon icon-info lead" data-tip='The current budget for the site excluding rechargeables and GST.'></i></strong>
                <ReactTooltip />
                {spendPerAccount && <table style={{fontSize: '0.8em'} }>
                    <tbody>
                        <tr>
                            <th className="text-right">Budget</th>
                            <th className="text-right">Current</th>
                            <th className="text-right">After Ord</th>
                        </tr>
                        {glCollection.map(function (accountData) {
                             return [<tr>
                                 <td colspan="3" style={{ fontStyle: 'italic'} }>{accountData.glAccount.name}:</td>
                             </tr>, <tr>
                                 <td className="text-right">{formatMoney(ifNull(accountData.amount))}</td>
                                 <td className="text-right">{formatMoney(ifNull(spendBreakDown[accountData.glAccount.code]))}</td>
                                 <td className="text-right">{formatMoney(ifNull(spendBreakDown[accountData.glAccount.code]) + ifNull(cartAccountSpend[accountData.glAccount.code]) )}</td>
                                </tr>]
                               
                        })}

                        <tr>
                            <td colspan="3" style={{ fontStyle: 'italic' }}>Not Allocated:</td>
                        </tr><tr>
                            <td className="text-right">{formatMoney(ifNull(monthlyBudget))}</td>
                            <td className="text-right">{formatMoney(ifNull(spendBreakDown[null]))}</td>
                            <td className="text-right">{formatMoney(ifNull(spendBreakDown[null]) + ifNull(cartAccountSpend[null]))}</td>
                        </tr>

     

                    </tbody>
                </table>}

                {!spendPerAccount &&
                    <table>
                        <tbody>
                            <tr>
                                <td>Budget:</td>
                                <td className="text-right">{formatMoney(monthlyBudget)}</td>

                            </tr>
                            <tr>
                                <td>Spend MTD:</td>
                                <td className="text-right">{formatMoney(monthlySpend)}</td>
                            </tr>
                            <tr>
                                <td>This order: <i className="icon icon-info" data-tip='This order will use this amount for the budget. It will exclude rechargeables.'></i></td>
                                <td className="text-right">{formatMoney(totalPrice)}</td>
                            </tr>
                            <tr>
                                <td>After order:</td>
                                <td className="text-right">{formatMoney(monthlySpend + totalPrice)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                }
            </div>
            </div>;
    }
}


export default withCart(SiteBudgetData);